<template>
  <div class="manager-container">
    <!--  头部  -->
    <div class="manager-header">
      <div class="manager-header-left">
        <img src="@/assets/imgs/logo.png" alt="系统Logo" />
        <div class="title">后台管理系统</div>
      </div>

      <div class="manager-header-center">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: $route.path }">{{ $route.meta.name || '页面' }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div class="manager-header-right">
        <el-dropdown placement="bottom">
          <div class="avatar">
            <img :src="user.avatar || 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png'" alt="用户头像" />
            <div>{{ user.name || '管理员' }}</div>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="logout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>

    <!--  主体  -->
    <div class="manager-main" :class="{ 'no-sidebar': user.role === 'USER' }">
      <!--  侧边栏 - USER 角色不显示  -->
      <div class="manager-main-left" v-if="user.role === 'ADMIN'">
        <el-menu
          :default-openeds="['device', 'user', 'log']"
          router
          :default-active="$route.path"
          background-color="#222b40"
          text-color="#ccc"
          active-text-color="#3399ff">

          <!-- 用户管理 - 仅 ADMIN 可见 -->
          <el-submenu index="user">
            <template slot="title">
              <i class="el-icon-s-custom"></i>
              <span>用户管理</span>
            </template>
            <el-menu-item index="/admin">管理员信息</el-menu-item>
            <el-menu-item index="/userManagement">用户管理</el-menu-item>
          </el-submenu>

          <!-- 设备管理 -->
          <el-submenu index="device">
            <template slot="title">
              <i class="el-icon-s-grid"></i>
              <span>设备管理</span>
            </template>
            <el-menu-item index="/device">设备信息</el-menu-item>
            <el-menu-item index="/commandSystem">指令系统</el-menu-item>
            <el-menu-item index="/deviceMap">设备地图</el-menu-item>
            <el-menu-item index="/geofence">电子围栏</el-menu-item>
            <el-menu-item index="/deviceMonitorLog">设备监控日志</el-menu-item>
          </el-submenu>

          <!-- 系统日志 - 仅 ADMIN 可见 -->
          <el-submenu index="log">
            <template slot="title">
              <i class="el-icon-s-order"></i>
              <span>系统日志</span>
            </template>
            <el-menu-item index="/log">操作日志</el-menu-item>
          </el-submenu>
        </el-menu>
      </div>

      <!--  主内容区域  -->
      <div class="manager-main-right" :class="{ 'full-width': user.role === 'USER' }">
        <router-view @update:user="updateUser" />
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "Manager",
  data() {
    return {
      user: {},
    }
  },
  created() {
    this.initUser()
  },
  methods: {
    initUser() {
      try {
        const userData = localStorage.getItem('xm-user')
        this.user = userData ? JSON.parse(userData) : {}
        
        // 检查用户信息和token是否完整
        if (!this.user.id || !this.user.accessToken) {
          console.warn('用户信息不完整，缺少ID或accessToken')
          this.clearUserAndRedirect()
          return
        }
        
        console.log('用户认证验证通过:', { id: this.user.id, hasToken: !!this.user.accessToken })
      } catch (error) {
        console.error('解析用户数据失败:', error)
        this.clearUserAndRedirect()
      }
    },
    updateUser() {
      try {
        const userData = localStorage.getItem('xm-user')
        this.user = userData ? JSON.parse(userData) : {}
      } catch (error) {
        console.error('更新用户数据失败:', error)
        this.user = {}
      }
    },
    goToPerson() {
      if (this.user.role === 'ADMIN') {
        this.$router.push('/adminPerson')
      }
    },
    clearUserAndRedirect() {
      try {
        localStorage.removeItem('xm-user')
        this.user = {}
        this.$router.push('/login')
      } catch (error) {
        console.error('清除用户数据失败:', error)
        // 即使出错也要跳转到登录页
        this.$router.push('/login')
      }
    },
    logout() {
      try {
        localStorage.removeItem('xm-user')
        this.$router.push('/login')
      } catch (error) {
        console.error('退出登录失败:', error)
        // 即使出错也要跳转到登录页
        this.$router.push('/login')
      }
    }
  },
  errorCaptured(err, vm, info) {
    console.error('Manager组件捕获到错误:', err, info)
    return false
  }
}
</script>

<style scoped>
@import "@/assets/css/manager.css";
</style>
